const PropTypes = require('prop-types');
const React = require('react');
const RelatedArticle = require('./related_article.jsx');
const { Tracker } = require('@reverbdotcom/discovery-ui');

class RelatedArticles extends React.Component {
  componentDidMount() {
    this.trackImpression();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.articles.length && this.props.articles.length) {
      this.trackImpression();
    }
  }

  trackImpression() {
    if (this.props.articles.length < 2) { return; }

    Tracker.view({
      name: 'RelatedArticleCard',
      type: 'article',
      ids: this.props.articles.map(article => article.id),
    });
  }

  render() {
    if (this.props.articles.length < 2) { return null; }

    return (
      <section
        className="article-condensed-card-row"
      >
        <section
          className="article-condensed-card-row__inner"
          data-admin-message={this.props.messageForAdmins}
        >
          {
            this.props.articles.map(article =>
              <RelatedArticle key={article.title} article={article} />
            )
          }
        </section>
      </section>
    );
  }
}

RelatedArticles.propTypes = {
  articles: PropTypes.array,
  messageForAdmins: PropTypes.string,
};

module.exports = RelatedArticles;



// WEBPACK FOOTER //
// ./javascripts/components/shared/related_articles.jsx